var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"secondary","flat":"","dense":""}},[_c('v-toolbar-title',[_vm._v("Z Report")]),_c('v-spacer')],1),_c('v-card-text',[(_vm.MultipleZendReports == 'Y')?_c('user-z-report'):_c('general-z-report')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }